export default __webpack_public_path__ + "static/media/Red.e9b8b6f2.svg";